import Naluri from '~/common/api/naluri'
import qs from 'qs'
import {
  FOOD_JOURNAL_SET_FILTERED_BEGIN,
  FOOD_JOURNAL_SET_FILTERED_SUCCESS,
  FOOD_JOURNAL_SET_FILTERED_FAILURE,
  FOOD_JOURNAL_SET_FILTERED_DISMISS_ERROR,
} from './constants';
import {List} from 'immutable'

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function setFiltered({uid, type, day}, page = 1) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: FOOD_JOURNAL_SET_FILTERED_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const params = qs.stringify({
        meal_time: type,
        meal_day: day,
        user_id: uid,
        page,
        per_page: 9
      })

      const doRequest = Naluri.get(`/api/expert/dishes?${params}`)

      doRequest.then(
        (res) => {
          dispatch({
            type: FOOD_JOURNAL_SET_FILTERED_SUCCESS,
            data: {
              listing: res.data,
              pagination: res.pagination
            }
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: FOOD_JOURNAL_SET_FILTERED_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSetFilteredError() {
  return {
    type: FOOD_JOURNAL_SET_FILTERED_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FOOD_JOURNAL_SET_FILTERED_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        listing: List(),
        listingPagination: { page: 1 },
        getJournalsPending: true,
        setFilteredPending: true,
        setFilteredError: null,
      };

    case FOOD_JOURNAL_SET_FILTERED_SUCCESS:
      // The request is success
      return {
        ...state,
        listing: state.listing.withMutations(journal =>
          action.data.listing.map(d => {
            let isExist = journal.find(n => n.id === d.id)
            return (!isExist) ? journal.push(d) : null
          })
        ),
        listingPagination: action.data.pagination,
        getJournalsPending: false,
        setFilteredPending: false,
        setFilteredError: null,
      };

    case FOOD_JOURNAL_SET_FILTERED_FAILURE:
      // The request is failed
      return {
        ...state,
        getJournalsPending: false,
        setFilteredPending: false,
        setFilteredError: action.data.error,
      };

    case FOOD_JOURNAL_SET_FILTERED_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        setFilteredError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/setFiltered.js